import React from 'react';
import { Typography, type TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';

interface GradientTextProps extends TypographyProps {
  children: React.ReactNode;
  gradient?: string;
}

const StyledTypography = styled(Typography)<{ component?: React.ElementType; gradient: string }>(({ theme, gradient }) => ({
  background: gradient,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
  textFillColor: 'transparent',
  display: 'inline-block', // Ensures the gradient is only applied to the text content
}));

const GradientText: React.FC<GradientTextProps> = ({
  children,
  gradient = 'linear-gradient(91deg, #2563EB 5.84%, #7C3AED 94.16%)',
  ...props
}) => {
  return (
    <StyledTypography gradient={gradient} {...props}>
      {children}
    </StyledTypography>
  );
};

export default GradientText;